import React from "react";

// MUI
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

// Styles
import styles from './style.module.scss';

type LoadingBackdropProps = {
  classes?: {
    root?: string;
  }
}

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({ classes }) => {
  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open={true}
      onClick={() => { }}
      classes={{
        root: `${styles.root} ${classes?.root}`
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export default LoadingBackdrop;
